import { Component } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-sidebar-accordion-user',
  templateUrl: './bary-sidebar-accordion-user.component.html',
  styleUrls: ['./bary-sidebar-accordion-user.component.scss'],
})
export class BarySidebarAccordionUserComponent {
  protected readonly PATHS = PATHS;
  protected readonly FAS = FaDirectiveEnum.FAS;
}
